export default "__VITE_ASSET__DoVN9WZa__"